/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react';

import { TextAction } from '@leagueplatform/genesis-core';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';

import { NotificationModal } from '../reusable-components/notificationModal.component';

export function TobaccoModal(props: any) {
  const {
    setShowModal,
    showModal,
    plans,
    demographics,
    showError,
    setShowError,
  } = props;

  const navigate = useNavigate();
  const prepopRetryCount = useRef(0);

  const [userTobacco, setUserTobacco] = useState(false);
  const [newPlans, setNewPlans] = useState([]);
  const demographicsNew: any = demographics;

  function getAge() {
    const today = new Date();
    const birthDate = new Date(demographicsNew.dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      // eslint-disable-next-line no-plusplus
      age--;
    }
    return age;
  }

  useEffect(() => {
    const newplans =
      plans?.length > 0 &&
      plans?.filter(
        (plan: any) =>
          plan?.planYear !== 'future' &&
          plan?.hcrProduct !== null &&
          plan?.hcrProduct !== undefined,
      );
    setNewPlans(newplans);
    setUserTobacco(newplans?.length > 0);
  }, [plans]);
  return (
    <>
      <NotificationModal
        modalOpen={showError}
        onOpenChange={() => {
          if (prepopRetryCount.current < 0) {
            setShowError((previous: boolean) => !previous);
            prepopRetryCount.current += 1;
          } else navigate('/home');
        }}
        type="Error"
        description="Oops! Something went wrong."
      />
      {plans &&
        Object.keys(newPlans).length > 0 &&
        userTobacco &&
        getAge() >= 18 && (
          <TextAction
            tabIndex={0}
            onKeyDown={(e: { key: string }) => {
              if (e.key === 'Enter' || e.key === ' ') {
                setShowModal(true);
              }
            }}
            onClick={() => setShowModal(true)}
            as="span"
            css={{
              fontSize: '$buttonOne',
              fontWeight: 'bold',
              lineHeight: '$oneAndHalf',
              letterSpacing: '-0.20000000298023224px',
              // padding: '$threeQuarters 21px',
              padding: showModal ? '$threeQuarters 21px' : '13px 0px',
              color: showModal
                ? '$onSurfaceTextPrimary'
                : '$interactiveActionPrimary',
              paddingLeft: showModal ? '' : '25px',
              paddingRight: showModal ? '' : '25px',
              borderLeft: showModal
                ? '4px solid $interactiveActionPrimary'
                : 'none',
              height: showModal ? '38px' : '',
            }}
          >
            Tobacco use status
          </TextAction>
        )}
    </>
  );
}
